export const OFFERS_PROMO_GRID_ID = 'offers-promo-grid';
export const SCROLL_OFFSET = 160;
export const CARD_KEY = 'card';
